import { useContext, useEffect } from 'react';
import { BiUserCircle } from 'react-icons/bi';
import PageContext from '../global_state/context/PageContext';
import SCSS from '../assets/scss/App.module.scss';
import '../assets/scss/Wordpress.scss';
import UserContext from 'global_state/context/UserContext';
import { addUserListener, addUserLogoutListener, removeUserListener, removeUserLogoutListener, triggerPageEvent } from 'eventFunctions';
import content from 'languages/Header.json'

function Header() {
  const {page, dispatchPage}  = useContext(PageContext)
  const {user, dispatchUser} = useContext(UserContext)
  
  let lang = page.settings.lang

  const handleClick = (e) => {
    // console.log(e);
    
    sessionStorage.setItem('xf_active_page', JSON.stringify('user_profile'));
    
    triggerPageEvent()
    let wp_page = process.env["REACT_APP_WP_PAGE_"+lang] || 'app'
    let xf_page = 'user_profile';

    let path_names = window.location.pathname.split('/')
    let on_page = false
    path_names.forEach((value) => {
      if (value == wp_page) {
          on_page = true
      }
    })

    // TODO: remove old xf_page if there is new one -> same for submenu
    if (!on_page) {
      let url_object = new URL(window.location.href)

      url_object.pathname = wp_page
      if (url_object.searchParams.has('xf_page')) {
        url_object.searchParams.set('xf_page', xf_page)
      } else {
        url_object.searchParams.append('xf_page', xf_page)
      }
      
      
      window.location.href = url_object.href
    }    
    document.getElementById('mp-menu-trigger')?.dispatchEvent(new Event('click'))
  }
  const renderMenuText = () => {
    // console.log('render Menu Text'.toUpperCase());
    
    // console.log(user);
    
    if (user.client_id != null) {
      return (content[lang].logged)
    }

    // console.log("return after logout");
    
    return (content[lang].log_in_sign_in)
  }

  useEffect(() => {
    // console.log("Header Component mounted".toUpperCase());
    
    addUserListener(dispatchUser)
    addUserLogoutListener(user, dispatchUser)
    return () => {
      // console.log("Header Component unmounted".toUpperCase());
      
      removeUserListener(dispatchUser)
      removeUserLogoutListener(user, dispatchUser)
    }
  }, [])


  return (
    <div onClick={e => handleClick(e)}>  
        <span className={SCSS.user_icon}><BiUserCircle></BiUserCircle></span>
        <span className={SCSS.uppercase}> {renderMenuText()}</span>
    </div>
  );
}

export default Header;